import { useMemo, useState } from "react";
import { Coins } from "lucide-react";
import { ToolLayout, TwoCol } from "@/components/tools/ToolLayout";
import { SectionCard, Field, MoneyInput, SliderRow, StatCard, compactINR } from "@/components/tools/kit";
import { GrowthArea, SplitDonut } from "@/components/tools/charts";
import { lumpsum } from "@/lib/calculators";

export default function Lumpsum() {
  const [principal, setPrincipal] = useState(1000000);
  const [rate, setRate] = useState(12);
  const [years, setYears] = useState(10);
  const r = useMemo(() => lumpsum({ principal, rate, years }), [principal, rate, years]);
  return (
    <ToolLayout title="Lumpsum Calculator" subtitle="Project a one-time investment's growth" icon={Coins} accent="#D99B26">
      <TwoCol
        left={
          <SectionCard title="Your investment">
            <div className="space-y-5">
              <Field label="Investment amount"><MoneyInput testid="ls-principal" value={principal} onChange={setPrincipal} helper={compactINR(principal)} /></Field>
              <Field label="Expected return (p.a.)" hint={rate + "%"}><SliderRow testid="ls-rate" value={rate} min={1} max={25} step={0.5} suffix="%" onChange={setRate} /></Field>
              <Field label="Time period" hint={years + " yrs"}><SliderRow testid="ls-years" value={years} min={1} max={40} suffix=" yr" onChange={setYears} /></Field>
            </div>
          </SectionCard>
        }
        right={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <StatCard testid="ls-invested" label="Invested" value={compactINR(r.invested)} accent="#2A6F7F" />
              <StatCard testid="ls-gains" label="Est. Gains" value={compactINR(r.gains)} accent="#D96B43" />
              <StatCard testid="ls-value" label="Future Value" value={compactINR(r.futureValue)} accent="#D99B26" big />
            </div>
            <SectionCard title="Growth over time"><GrowthArea data={r.points} keys={[{ key: "value", name: "Value", color: "#D99B26" }]} /></SectionCard>
            <SectionCard title="Invested vs Gains"><SplitDonut segments={[{ name: "Invested", value: Math.round(r.invested), color: "#2A6F7F" }, { name: "Gains", value: Math.round(r.gains), color: "#D96B43" }]} /></SectionCard>
          </>
        }
      />
    </ToolLayout>
  );
}
